import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar", "overlay"]
  connect() {
    this.element[this.identifier] = this;
    if (this.sidebarOpen) {
      this.openSidebar();
    } else {
      this.closeSidebar();
    }
  }

  toggleSidebar() {
    if (this.sidebarOpen) {
      this.closeSidebar();
    } else {
      this.openSidebar();
    }
  }

  get sidebarOpen() {
    return localStorage.getItem('sidebar-expanded') === 'true';
  }

  openSidebar() {
    document.body.classList.add('sidebar-expanded');
    localStorage.setItem('sidebar-expanded', true);
    this.sidebarTarget.classList.remove('-translate-x-64');
    this.sidebarTarget.classList.add('translate-x-0');
    this.overlayTarget.classList.remove('hidden');
  }

  closeSidebar() {
    document.body.classList.remove('sidebar-expanded');
    localStorage.setItem('sidebar-expanded', false);
    this.sidebarTarget.classList.remove('translate-x-0');
    this.sidebarTarget.classList.add('-translate-x-64');
    this.overlayTarget.classList.add('hidden');
  }
}
